document.addEventListener('DOMContentLoaded', function () {
  const set1 = [
    {
      option1: {
        img: 'https://herlipto.jp/cdn/shop/files/0813ROSIER_12975_4df2f8ca-6ea0-48b4-a87d-a3952bc63d16_small.jpg?v=1763185038',
        value: 'nude rose',
      },
      option2: [
        {
          url: 'https://herlipto.myshopify.com/cart/44686697365698:1?channel=buy_button',
          value: 's',
        },
        {
          url: 'https://herlipto.myshopify.com/cart/44686697398466:1?channel=buy_button',
          value: 'm',
        },
        {
          url: 'https://herlipto.myshopify.com/cart/44686697431234:1?channel=buy_button',
          value: 'l',
        },
        {
          url: 'https://herlipto.myshopify.com/cart/45504247791810:1?channel=buy_button',
          value: 'xl',
        },
      ],
    },
    {
      option1: {
        img: 'https://herlipto.jp/cdn/shop/files/Frame_53_2_small.jpg?v=1763185038',
        value: 'black',
      },
      option2: [
        {
          url: 'https://herlipto.myshopify.com/cart/44834665529538:1?channel=buy_button',
          value: 's',
        },
        {
          url: 'https://herlipto.myshopify.com/cart/44834665562306:1?channel=buy_button',
          value: 'm',
        },
        {
          url: 'https://herlipto.myshopify.com/cart/44834665595074:1?channel=buy_button',
          value: 'l',
        },
        {
          url: 'https://herlipto.myshopify.com/cart/45504247824578:1?channel=buy_button',
          value: 'xl',
        },
      ],
    },
  ];
  const set2 = [
    {
      option1: {
        img: 'https://herlipto.jp/cdn/shop/files/Perfect_Hip_Girdle_2_Set_1_small.jpg?v=1761137787',
        value: 'nude rose × nude rose',
      },
      option2: [
        {
          url: 'https://herlipto.myshopify.com/cart/45834224632002:1?channel=buy_button',
          value: 's',
        },
        {
          url: 'https://herlipto.myshopify.com/cart/45834270703810:1?channel=buy_button',
          value: 'm',
        },
        {
          url: 'https://herlipto.myshopify.com/cart/45834270736578:1?channel=buy_button',
          value: 'l',
        },
        {
          url: 'https://herlipto.myshopify.com/cart/45873919164610:1?channel=buy_button',
          value: 'xl',
        },
      ],
    },
    {
      option1: {
        img: 'https://herlipto.jp/cdn/shop/files/Perfect_Hip_Girdle_2_Set_2_small.jpg?v=1761137787',
        value: 'black × black',
      },
      option2: [
        {
          url: 'https://herlipto.myshopify.com/cart/45834224763074:1?channel=buy_button',
          value: 's',
        },
        {
          url: 'https://herlipto.myshopify.com/cart/45834270769346:1?channel=buy_button',
          value: 'm',
        },
        {
          url: 'https://herlipto.myshopify.com/cart/45834270802114:1?channel=buy_button',
          value: 'l',
        },
        {
          url: 'https://herlipto.myshopify.com/cart/45873919197378:1?channel=buy_button',
          value: 'xl',
        },
      ],
    },
    {
      option1: {
        img: 'https://herlipto.jp/cdn/shop/files/Perfect_Hip_Girdle_2_Set_3_small.jpg?v=1761137787',
        value: 'nude rose × black',
      },
      option2: [
        {
          url: 'https://herlipto.myshopify.com/cart/45834247700674:1?channel=buy_button',
          value: 's',
        },
        {
          url: 'https://herlipto.myshopify.com/cart/45834270834882:1?channel=buy_button',
          value: 'm',
        },
        {
          url: 'https://herlipto.myshopify.com/cart/45834270867650:1?channel=buy_button',
          value: 'l',
        },
        {
          url: 'https://herlipto.myshopify.com/cart/45873919230146:1?channel=buy_button',
          value: 'xl',
        },
      ],
    },
  ];

  const set3 = [
    {
      option1: {
        img: 'https://herlipto.jp/cdn/shop/files/Perfect_Hip_Girdle_3_Set_1_small.jpg?v=1761140436',
        value: 'nude rose × nude rose × nude rose',
      },
      option2: [
        {
          url: 'https://herlipto.myshopify.com/cart/45834248552642:1?channel=buy_button',
          value: 's',
        },
        {
          url: 'https://herlipto.myshopify.com/cart/45834259529922:1?channel=buy_button',
          value: 'm',
        },
        {
          url: 'https://herlipto.myshopify.com/cart/45834259562690:1?channel=buy_button',
          value: 'l',
        },
        {
          url: 'https://herlipto.myshopify.com/cart/45834259595458:1?channel=buy_button',
          value: 'xl',
        },
      ],
    },
    {
      option1: {
        img: 'https://herlipto.jp/cdn/shop/files/Perfect_Hip_Girdle_3_Set_3_small.jpg?v=1761140436',
        value: 'nude rose × nude rose × black',
      },
      option2: [
        {
          url: 'https://herlipto.myshopify.com/cart/45834249142466:1?channel=buy_button',
          value: 's',
        },
        {
          url: 'https://herlipto.myshopify.com/cart/45834259628226:1?channel=buy_button',
          value: 'm',
        },
        {
          url: 'https://herlipto.myshopify.com/cart/45834259660994:1?channel=buy_button',
          value: 'l',
        },
        {
          url: 'https://herlipto.myshopify.com/cart/45834259693762:1?channel=buy_button',
          value: 'xl',
        },
      ],
    },
    {
      option1: {
        img: 'https://herlipto.jp/cdn/shop/files/Perfect_Hip_Girdle_3_Set_4_small.jpg?v=1761140436',
        value: 'nude rose × black × black',
      },
      option2: [
        {
          url: 'https://herlipto.myshopify.com/cart/45834249437378:1?channel=buy_button',
          value: 's',
        },
        {
          url: 'https://herlipto.myshopify.com/cart/45834259726530:1?channel=buy_button',
          value: 'm',
        },
        {
          url: 'https://herlipto.myshopify.com/cart/45834259759298:1?channel=buy_button',
          value: 'l',
        },
        {
          url: 'https://herlipto.myshopify.com/cart/45834259792066:1?channel=buy_button',
          value: 'xl',
        },
      ],
    },
    {
      option1: {
        img: 'https://herlipto.jp/cdn/shop/files/Perfect_Hip_Girdle_3_Set_2_small.jpg?v=1761140436',
        value: 'black × black × black',
      },
      option2: [
        {
          url: 'https://herlipto.myshopify.com/cart/45834248847554:1?channel=buy_button',
          value: 's',
        },
        {
          url: 'https://herlipto.myshopify.com/cart/45834259824834:1?channel=buy_button',
          value: 'm',
        },
        {
          url: 'https://herlipto.myshopify.com/cart/45834259857602:1?channel=buy_button',
          value: 'l',
        },
        {
          url: 'https://herlipto.myshopify.com/cart/45834259890370:1?channel=buy_button',
          value: 'xl',
        },
      ],
    },
  ];

  // データセットに応じたDOMを生成する関数
  function generateModalContent(setName) {
    const dataMap = {
      set1: set1,
      set2: set2,
      set3: set3,
    };

    const data = dataMap[setName];
    if (!data) return;

    const variantSelectsModalBody = document.querySelector('.product-form__variant-selects-modal__body');
    // 既存のコンテンツをクリア
    variantSelectsModalBody.innerHTML = '';

    data.forEach((item) => {
      // option要素を作成
      const optionDiv = document.createElement('div');
      optionDiv.className = 'product-form__variant-selects-modal__option js-variant-selects-modal__option';

      // option head部分を作成
      const headDiv = document.createElement('div');
      headDiv.className = 'product-form__variant-selects-modal__option__head js-variant-selects-modal__option__head';

      const img = document.createElement('img');
      img.src = item.option1.img;
      img.className = 'product-form__variant-selects-modal__option__head__img';

      const nameDiv = document.createElement('div');
      nameDiv.className = 'product-form__variant-selects-modal__option__head__name';
      nameDiv.textContent = item.option1.value;

      const arrowDiv = document.createElement('div');
      arrowDiv.className = 'product-form__variant-selects-modal__option__head__arrow';

      headDiv.appendChild(img);
      headDiv.appendChild(nameDiv);
      headDiv.appendChild(arrowDiv);

      // variants部分を作成
      const variantsUl = document.createElement('ul');
      variantsUl.className = 'product-form__variant-selects-modal__variants';

      item.option2.forEach((variant) => {
        const li = document.createElement('li');

        const variantNameDiv = document.createElement('div');
        variantNameDiv.className = 'product-form__variant-selects-modal__variants__name';
        variantNameDiv.textContent = variant.value;

        const actionDiv = document.createElement('div');
        actionDiv.className = 'c-Variants__action';

        const a = document.createElement('a');
        a.href = variant.url;
        a.className = 'product-form__variant-selects-modal__variants__button button button--primary button--addToCart js-add-to-cart';

        const span = document.createElement('span');
        span.textContent = '購入する';
        a.appendChild(span);

        actionDiv.appendChild(a);

        li.appendChild(variantNameDiv);
        li.appendChild(actionDiv);

        variantsUl.appendChild(li);
      });

      optionDiv.appendChild(headDiv);
      optionDiv.appendChild(variantsUl);

      variantSelectsModalBody.appendChild(optionDiv);
    });
  }

  const variantSelectsModal = document.querySelector('.product-form__variant-selects-modal');

  // モーダルをbodyの直下に移動してスタッキングコンテキストの問題を回避
  if (variantSelectsModal) {
    document.body.appendChild(variantSelectsModal);
  }

  // variant selects modalの開閉
  const variantSelectsModalOpenButtons = document.querySelectorAll('.js-variant-selects-modal');
  const variantSelectsModalCloseButtons = document.querySelectorAll('.js-variant-selects-modal__close');
  variantSelectsModalOpenButtons.forEach((variantSelectsModalOpenButton) => {
    variantSelectsModalOpenButton.addEventListener('click', (e) => {
      e.preventDefault();
      // data-set属性を読み取ってDOM生成
      const setName = variantSelectsModalOpenButton.dataset.set;
      generateModalContent(setName);

      variantSelectsModal.style.display = 'block';
      document.body.classList.add('modal-open');
    });
  });
  variantSelectsModalCloseButtons.forEach((variantSelectsModalCloseButton) => {
    variantSelectsModalCloseButton.addEventListener('click', () => {
      variantSelectsModal.style.display = 'none';
      document.body.classList.remove('modal-open');
    });
  });
  const variantSelectsModalContent = document.querySelector('.product-form__variant-selects-modal__content');
  variantSelectsModal.addEventListener('click', (event) => {
    if (!variantSelectsModalContent.contains(event.target)) {
      variantSelectsModal.style.display = 'none';
      document.body.classList.remove('modal-open');
    }
  });

  // optionの開閉（イベント委譲）
  variantSelectsModal.addEventListener('click', (e) => {
    const target = e.target.closest('.js-variant-selects-modal__option__head');
    if (target) {
      const optionElement = target.closest('.product-form__variant-selects-modal__option');
      if (optionElement) {
        optionElement.classList.toggle('is-active');
      }
    }
  });

  // add to cart（イベント委譲）
  variantSelectsModal.addEventListener('click', (e) => {
    const target = e.target.closest('.js-add-to-cart');
    if (target) {
      btnLoading(target);
    }
  });

  function btnLoading(target) {
    target.classList.add('is-loading');
    if (!target.querySelector('.loading')) {
      const loading = document.createElement('span');
      loading.classList.add('loading');
      target.appendChild(loading);
    }
  }

  window.addEventListener('pageshow', function () {
    const loadingEles = document.querySelectorAll('.is-loading');
    loadingEles.forEach((loadingEle) => {
      loadingEle.classList.remove('is-loading');
    });
  });
});
